import { graphql } from "../gql";

export const updateAuditRuleMutationDoc = graphql(`
  mutation uiUpdateRuleV2($input: GQLAuditRuleInput!) {
    uiUpdateRuleV2(input: $input) {
      id
      name
      status
      selectCodeStr
      evaluateCodeStr
      createdAt
      createdBy
    }
  }
`);
